import React from 'react';
import form_styles from "../Form/Form.module.css";
import { ReactComponent as EnregistrerIcon } from '../../icons/enregistrer.svg';

const BtnSave = ({ isSubmitting, text = "Enregistrer" }) => {
    return (
        <button className={`btn ${form_styles.btnSubmit}`} type="submit"
                disabled={isSubmitting}><EnregistrerIcon style={{ height: "16px", width: "auto", fill: "white", color: "white"}}/> {text}
        </button>
    );
};

export default BtnSave;
